import { Injectable } from '@angular/core';
import { CwtCurrencyService } from '@cawita/core-front';
import { isNumber, isString } from '@hints/utils/types';
import { CurrencyService } from '@server-shared';

@Injectable()
export class CustomCurrencyService extends CwtCurrencyService {
  format(value: string | number, currencyCode?: string,): string {
    if (isNumber(value)) value = CurrencyService.round(value);
    if (isString(value)) value = CurrencyService.round(Number(value));
    return CurrencyService.format(value, 'fr-FR', currencyCode);
  }
}